import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {CaptionManager} from "./CaptionManager";

export class VoiceOverManager {

    static get instance() {
        return this._instance || (this._instance = new VoiceOverManager());
    }

    public get active() {
        return this.ccManager.active ||
            (this.audioManager.masterVolume !== 0 && this.audioManager.getCategoryVolume(HLF.AudioCategory.VO) !== 0);
    }

    private static _instance: VoiceOverManager;

    private readonly audioManager = Application.instance.audio;
    private readonly voManager = Application.instance.voiceover;
    private readonly ccManager = CaptionManager.instance;

    private currentCallback?: (b: boolean) => void;

    public playVO(key: string | (string | number)[], options: HLF.IPlayOptions) {
        if (!this.active) {
            if (options.callback) {
                window.setTimeout(() => {
                    options.callback!(false);
                }, 10);
            }
        } else {
            const cb = options.callback;
            let isPlaying = true;
            options.callback = (b) => {
                isPlaying = b;
                if (b) {
                    this.callback(b);
                }
            };
            this.voManager.playVO(key, options);
            if (isPlaying) {
                this.callback(false);
                this.currentCallback = cb;
            } else if (cb) {
                cb(false);
            }
        }
    }

    public stopVO() {
        this.voManager.stopVO();
        this.callback(false);
    }

    private callback(b: boolean) {
        if (this.currentCallback) {
            const cb = this.currentCallback;
            this.currentCallback = undefined;
            cb(b);
        }
    }
}
